// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"47c3c6d6","977":"4f67b736"}[chunkId] + ".chunk.js";
};